<template>
  <select @change="selectChangeHandler" :id="`select${selectId}`">
    <option v-for="(item, index) in items" :key="index" :value="typeof item === 'object' ? item.value : item">
      {{ typeof item === 'object' ? $t(item.key) : $t(item) }}
    </option>
  </select>
</template>

<script>
export default {
  props: {
    selectId: Number,
    items: {
      type: Array,
      default: function () {
        return []
      }
    },
    selectedItem: {
      type: [String, Object]
    },
    reset: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      item: null
    }
  },
  computed: {
    computeCustomClass() {
      return `custom-select${this.selectId}`
    }
  },
  mounted() {
    this.item = this.items[0]
    this.$emit(`selectChangeHandler${this.selectId}`, this.item)
  },
  methods: {
    selectChangeHandler(event) {
      this.item = this.items.filter(el => event.target.value === (typeof this.item === 'object' ? el.value : el))[0]
      this.$emit(`selectChangeHandler${this.selectId}`, this.item)
    }
  },
  watch: {
    selectedItem(val) {
      if (val !== this.item) {
        this.item = val
        document.querySelector(`#select${this.selectId}`).value = val.value
      }
    },
    items() {
      this.item = this.items[0]
      document.querySelector(`#select${this.selectId}`).value = this.item.value
      this.$emit(`selectChangeHandler${this.selectId}`, this.item)
    }
  }
}
</script>

<style scoped>
select {
  display: inline-block;
  font-size: 17px;
  font-weight: normal;
  border-radius: 4px;
  padding: 0px 32px;
  width: 100%;
  height: 37px;
  /* reset */
  margin: 0;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-appearance: none;
  -moz-appearance: none;
}

.theme--dark select {
  background-color: var(--v-primary-lighten2);
  border: 1px solid var(--v-primary-lighten2);
  background-image:
    linear-gradient(45deg, transparent 50%, white 50%),
    linear-gradient(135deg, white 50%, transparent 50%);
  background-position: calc(100% - 20px) calc(0.95em), calc(100% - 15px) calc(0.95em), calc(100% - 2.0em) 0.5em;
  background-size:
    5px 5px,
    5px 5px,
    1px 1.5em;
  background-repeat: no-repeat;
}

.theme--dark select:active {
  background-image:
    linear-gradient(45deg, white 50%, transparent 50%),
    linear-gradient(135deg, transparent 50%, white 50%);
  background-position:
    calc(100% - 15px) 0.95em,
    calc(100% - 20px) 0.95em,
    calc(100% - 2.5em) 0.5em;
  background-size:
    5px 5px,
    5px 5px,
    1px 1.5em;
  background-repeat: no-repeat;
  border-color: none;
  outline: 0;
}

.theme--light select {
  border: 1px solid var(--v-primary-darken1);
  background: var(--v-primary-darken1);
  background-image:
    linear-gradient(45deg, transparent 50%, black 50%),
    linear-gradient(135deg, black 50%, transparent 50%);
  background-position: calc(100% - 20px) calc(0.95em), calc(100% - 15px) calc(0.95em), calc(100% - 2.0em) 0.5em;
  background-size:
    5px 5px,
    5px 5px,
    1px 1.5em;
  background-repeat: no-repeat;
}

.theme--light select:active {
  background-image:
    linear-gradient(45deg, black 50%, transparent 50%),
    linear-gradient(135deg, transparent 50%, black 50%);
  background-position:
    calc(100% - 15px) 0.95em,
    calc(100% - 20px) 0.95em,
    calc(100% - 2.5em) 0.5em;
  background-size:
    5px 5px,
    5px 5px,
    1px 1.5em;
  background-repeat: no-repeat;
  border-color: none;
  outline: 0;
}

</style>
